<template>
  <Header msg="" />
  <div class="container"></div>
  <div class="confirm-page-body">
    <h1 class="page-title">お見積内容</h1>
    <div class="box-data">
      <div class="box-data-left">
        <div class="box-left-title">
          <span> 商品概要 </span>
          <button class="h5 ml-5 icon-circle" @click="removeData">
            <BIconTrash />
          </button>
        </div>

        <div
          class="box-data-if"
          v-if="
            estimateStore.state.orderType === 'posting' ||
            estimateStore.state.orderType === 'posting_and_print'
          "
        >
          <div class="tes-cart-group-wrap">
            <!-- posting temporally use blank -->

            <div
              :class="
                device.mobile ? 'cart-container-mobile' : 'cart-container'
              "
            >
              <!-- <div class="menu-dummy"></div> -->
              <div
                :class="device.mobile ? 'cart-content-mobile' : 'cart-content'"
              >
                <!-- <div> -->
                <div class="space"></div>
                <div
                  class="summary-contents"
                  v-html="getSpecification(postingData)"
                ></div>
              </div>

              <div
                :class="device.mobile ? 'cart-content-mobile' : 'cart-content'"
              >
                <template
                  v-if="
                    postingData.estimation_objects &&
                    postingData.estimation_objects[0].active
                  "
                >
                  <div class="space"></div>
                  <div
                    v-if="
                      postingData.data_type === 'posting_and_print' &&
                      postingData.estimation_objects[0].print_sub_total_price
                    "
                    class="product-row"
                  >
                    <!-- <div class="left-col">印刷単価:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[0].print_sub_total_price?.toLocaleString()
                      }}円
                    </div> -->
                  </div>
                  <div
                    v-if="
                      postingData.estimation_objects[0].direct_delivery_count
                    "
                    class="product-row"
                  >
                    <div class="left-col">お手元送付分:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[0].direct_delivery_count?.toLocaleString()
                      }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">単価:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[0]?.unit_price.toLocaleString()
                      }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">小計:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[0].sub_total_price?.toLocaleString()
                      }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">消費税:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[0].tax.toLocaleString()
                      }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">合計金額:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[0].total_price.toLocaleString()
                      }}円
                    </div>
                  </div>
                </template>
                <template
                  v-if="
                    postingData.estimation_objects &&
                    postingData.estimation_objects[1].active
                  "
                >
                  <div class="title">商品キャンペーン価格</div>
                  <div class="space"></div>
                  <div
                    v-if="
                      postingData.data_type === 'posting_and_print' &&
                      postingData.estimation_objects[1].print_sub_total_price
                    "
                    class="product-row"
                  >
                    <!-- <div class="left-col">印刷単価:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[1].print_sub_total_price?.toLocaleString()
                      }}円
                    </div> -->
                  </div>
                  <div
                    v-if="
                      postingData.estimation_objects[0].direct_delivery_count
                    "
                    class="product-row"
                  >
                    <div class="left-col">お手元送付分:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[0].direct_delivery_count?.toLocaleString()
                      }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">単価:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[1].unit_price.toLocaleString()
                      }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">小計:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[1].sub_total_price.toLocaleString()
                      }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">消費税:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[1].tax.toLocaleString()
                      }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">合計金額:</div>
                    <div class="right-col">
                      {{
                        postingData.estimation_objects[1].total_price.toLocaleString()
                      }}円
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div
          class="box-data-if tes-cart-group-wrap"
          v-if="estimateStore.state.orderType === 'geenie'"
        >
          <div>
            <div class="product-row">
              <div class="left-col">消費税:</div>
              <div class="right-col">
                {{ geenieData.extra.ref_text }}
              </div>
            </div>
            <div class="product-row">
              <div class="left-col">ランディングページURL:</div>
              <div class="right-col">
                {{ geenieData.landing_page_url }}
              </div>
            </div>
            <div class="product-row">
              <div class="left-col">最終ランディングページURL:</div>
              <div class="right-col">
                {{ geenieData.final_landing_page_url }}
              </div>
            </div>
            <div class="product-row">
              <div class="left-col">選択地域の人口:</div>
              <div class="right-col">
                {{ geenieData.total_populations.toLocaleString() }}
              </div>
            </div>
            <div class="product-row">
              <div class="left-col">選択地域の世帯数:</div>
              <div class="right-col">
                {{ geenieData.total_households.toLocaleString() }}
              </div>
            </div>
            <div class="product-row">
              <div class="left-col">日付:</div>
            </div>
            <div class="product-row">
              <div class="left-col">
                {{ geenieData.start_date_time }} -
                {{ geenieData.finish_date_time }}
              </div>
            </div>
          </div>

          <div>
            <div class="product-row">
              <div class="left-col">広告予算:</div>
              <div class="right-col">
                {{ geenieData.budget.toLocaleString() }}
              </div>
            </div>
            <div class="product-row">
              <div class="left-col">税金:</div>
              <div class="right-col">
                {{ (geenieData.budget * 0.1).toLocaleString() }}
              </div>
            </div>
            <div class="product-row">
              <div class="left-col">広告予算:</div>
              <div class="right-col">
                {{
                  (geenieData.budget * 0.1 + geenieData.budget).toLocaleString()
                }}
              </div>
            </div>
          </div>

          <img :src="'data:image/jpeg;base64,' + geenieData.media.file_data" />
        </div>

        <div
          class="box-data-if"
          v-if="estimateStore.state.orderType === 'orikomi'"
        >
          <!-- <div
            class="cart-group-wrap-header"
          >
            <div>
              <b class="order-group-id"
                >注文GrID:{{ orikomiData.extra.group_id }} 作成:{{
                  orikomiData.extra.user_name
                }}</b
              >
              <div class="plan-created-at">
                カート投入日時:{{ orikomiData.created_at }}
              </div>
            </div>
            <button
              v-if="checkOrgStatus(orikomiData)"
              class="authorized-check-btn"
              @click="startAuthorizedProcess(orikomiData.extra.group_id, 'orikomi')"
            >
              :未承認
            </button>
            <div
              v-else-if="
                authorizeStatus(orikomiData) && authStore.state.orgType != 0
              "
              class="authorized-check-btn"
            >
              <BIconCheckLg class="check-icon" />
              承認済
            </div>
          </div> -->
          <div
            class="tes-cart-group-wrap"
            v-if="orikomiData.data_type == 'orikomi'"
          >
            <div
              :class="
                device.mobile ? 'cart-container-mobile' : 'cart-container'
              "
            >
              <!-- <div class="menu-dummy"></div> -->
              <div
                :class="device.mobile ? 'cart-content-mobile' : 'cart-content'"
              >
                <!-- <div> -->
                <b class="title">商品概要</b>
                <div class="space"></div>
                <div
                  class="summary-contents"
                  v-html="getSpecificationOrikomi(orikomiData)"
                ></div>
              </div>

              <div
                :class="device.mobile ? 'cart-content-mobile' : 'cart-content'"
              >
                <template v-if="true">
                  <b class="title">商品価格</b>
                  <div class="space"></div>
                  <div class="product-row">
                    <div class="left-col">単価:</div>
                    <div class="right-col">
                      {{ orikomiData.estimation.unit_price.toLocaleString() }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">小計:</div>
                    <div class="right-col">
                      {{
                        orikomiData.estimation.total_price.toLocaleString()
                      }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">消費税:</div>
                    <div class="right-col">
                      {{ orikomiData.estimation.tax.toLocaleString() }}円
                    </div>
                  </div>
                  <div class="product-row">
                    <div class="left-col">合計金額:</div>
                    <div class="right-col">
                      {{
                        orikomiData.estimation.include_tax.toLocaleString()
                      }}円
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <!-- <div
                v-if="i != Object.keys(planArray).length - 1"
                class="divider-border"
              ></div> -->
          </div>
        </div>

        <div class="body-input-ref normal-size-text">
          <span class="font-bold">
            <span v-if="estimateStore.state.orderType === 'posting'">
              チラシの名称
            </span>
            <span v-else> 例 居酒屋●●赤阪店: </span>
            <span class="font-red">*</span>
          </span>
          <input
            v-model="reffText"
            class="input-ref"
            :class="{ 'color-black': reffText }"
            placeholder="例 居酒屋●●赤阪店: "
            type="text"
          />
        </div>
      </div>

      <div class="box-data-right">
        <span class="font-bold font-size-large">配布地域</span>

        <div
          v-if="
            estimateStore.state.orderType === 'posting' ||
            estimateStore.state.orderType === 'posting_and_print'
          "
          class="box-data-info"
        >
          <div>
            <div
              :class="device.mobile ? 'cart-content-mobile' : 'cart-content'"
            >
              <div class="space"></div>
              <div
                v-if="postingData.area_block_objects"
                class="product-row"
                v-for="(area_block, j) in addressListShorthand(
                  postingData.area_block_objects
                )"
              >
                <div
                  class="left-col"
                  :class="area_block.dup == 1 ? 'font-dup' : ''"
                >
                  {{ area_block.address }}
                </div>
                <div class="right-col">
                  {{ area_block.rounded_quantity.toLocaleString() }}部
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="items-detail"
          v-if="estimateStore.state.orderType === 'geenie'"
        >
          <div v-for="area_block in geenieData.area_block_objects">
            <div class="geocode-geenie">
              {{ area_block.geocode }} - {{ area_block.address }}
            </div>
          </div>
        </div>

        <div
          class="items-detail detail-container"
          v-if="estimateStore.state.orderType === 'orikomi'"
        >
          <div v-for="(item, j) in orikomiData.estimation.items" :key="j">
            <div class="brand-title">銘柄: {{ item.brand_name }}</div>
            <div v-for="(store, k) in item.sales_stores" :key="k">
              <div class="product-row">
                <div class="left-col">{{ store.store_name }}</div>
                <div class="right-col">
                  {{ store.quantity.toLocaleString() }} /
                  {{ store.available_quantity.toLocaleString() }}部
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      @click="savePlan"
      :class="{ 'opacity-40': !reffText }"
      :disabled="!reffText"
      class="confirm-button"
    >
      カートへ入れる
    </button>
  </div>

  <Footer :relative="true" />
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header.vue";
import { estimateStore } from "../store/estimate-store";
import building from "../assets/img/building.png";
import { BIconTrash } from "bootstrap-icons-vue";
import backendApi from "../apis/backend-api";
import { authStore } from "../store/auth-store";
import { createDeviceDetector } from "next-vue-device-detector";
import { allMenuStore } from "../store/all-menu-store";
import encryptData from "../utils/encryptData";
const device = createDeviceDetector();

export default {
  name: "ConfirmOrder",
  components: {
    Footer,
    Header,
    BIconTrash,
  },
  data() {
    return {
      device,
      allMenuStore,
      estimateStore,
      building,
      estimatateObj: {},
      reffText: "",
    };
  },
  methods: {
    deliveryDateFormatAM(date, dataType) {
      if(dataType === "posting") {
        console.log(date, "ashkakjjhsahj")
        return "AM " + date
      } else {
        return "AM"
      }
    },
    addressListShorthand(areaBlocks) {
      let simpleAreaBlocks = [];
      let beforeAddress = "";
      let culc = 0;
      let dupCulc = 0;
      for (let i = 0; i < areaBlocks.length; i++) {
        areaBlocks[i].address = areaBlocks[i].address.split("(")[0];

        if (beforeAddress == areaBlocks[i].address) {
          beforeAddress = areaBlocks[i].address;
          culc = culc + Number(areaBlocks[i - 1].quantity);
          if (areaBlocks[i].dup == 1) {
            dupCulc = dupCulc + Number(areaBlocks[i - 1].quantity);
          }
          //areaBlocks[i].quantity = Number(areaBlocks[i].quantity) + Number(areaBlocks[i - 1].quantity)
        } else {
          beforeAddress = areaBlocks[i].address;
          if (i != 0) {
            let newObj = JSON.parse(JSON.stringify(areaBlocks[i - 1]));
            //  areaBlocks[i - 1].quantity = culc + Number(areaBlocks[i - 1].quantity)
            newObj.quantity = culc + Number(newObj.quantity);
            newObj.dup_quantity = dupCulc + Number(newObj.quantity);
            culc = 0;
            dupCulc = 0;
            simpleAreaBlocks.push(newObj);
            // continue
          }
        }

        if (i == areaBlocks.length - 1) {
          let newObj = JSON.parse(JSON.stringify(areaBlocks[i]));
          newObj.quantity = culc + Number(newObj.quantity);
          newObj.dup_quantity = dupCulc + Number(newObj.quantity);
          culc = 0;
          dupCulc = 0;
          simpleAreaBlocks.push(newObj);
        }
      }
      return simpleAreaBlocks;
    },
    getSummaryOrikomi(plan) {
      let preSpecification = "";
      if (plan.extra.points.length >= 3) {
        preSpecification =
          "新聞折込 :中心部: " +
          plan.extra.points[0] +
          plan.extra.points[1] +
          plan.extra.points[2] +
          "&nbsp;&nbsp; / 部数:" +
          plan.estimation.quantity.toLocaleString();

        if (!plan.extra.points[0]) {
          preSpecification =
            "新聞折込 :中心部: " +
            "ただいま確認中" +
            "&nbsp;&nbsp; / 部数:" +
            plan.estimation.quantity.toLocaleString();
        }
      } else if (plan.estimation.quantity) {
        preSpecification =
          "新聞折込 :部数: " + plan.estimation.quantity.toLocaleString();
      } else {
        preSpecification = "新聞折込 :部数: ただいま確認中";
      }
      if (plan.extra.ref_text && !device.mobile) {
        preSpecification =
          preSpecification +
          "&nbsp;&nbsp; / 参照テキスト:" +
          plan.extra.ref_text;
      }
      return preSpecification;
    },
    getSpecificationOrikomi(plan) {
      let preSpecification = "";
      if (plan.extra.points.length >= 3) {
        preSpecification =
          "<p class='left'>中心部:&nbsp;" +
          plan.extra.points[0] +
          plan.extra.points[1] +
          plan.extra.points[2] +
          "</p>";
      }

      let blandNames = "";
      for (let i = 0; i < plan.estimation.items.length; i++) {
        if (i == 0) {
          blandNames = plan.estimation.items[i].brand_name;
        } else {
          blandNames =
            blandNames + "&nbsp;/&nbsp;" + plan.estimation.items[i].brand_name;
        }
      }
      preSpecification =
        preSpecification +
        "<p>新聞銘柄:&nbsp;" +
        blandNames +
        "</p>" +
        "<p><span class='font-bold'>用紙サイズ:&nbsp;</span>" +
        plan.paper_size +
        "&nbsp;/&nbsp;<span class='font-bold'>厚さ:&nbsp;</span>" +
        plan.thickness +
        "</p>" +
        "<p>折込部数:&nbsp;" +
        plan.estimation.quantity.toLocaleString() +
        "</p>";
      return preSpecification;
    },
    getSpecification(plan) {
      let preSpecification = "";
      if (plan.extra?.posting_area) {
        preSpecification =
          "<div class='left-col'>配布エリア:&nbsp;" +
          plan.extra?.posting_area +
          "</div>";
      }
      let specification = "";

      if (plan.data_type === "posting") {
        specification =
          preSpecification +
          "<div>配布中心部:&nbsp;" +
          plan.extra?.central_name +
          "</div>" +
          "<div><span class='font-bold'>用紙サイズ:&nbsp;</span>" +
          allMenuStore.getters.findPaperSizeJName(plan.paper_size) +
          " / 配布部数:&nbsp;" +
          plan.computed_quantity.toLocaleString() +
          "</div>" +
          "<div>配布方法:&nbsp;" +
          allMenuStore.getters.findMethodsJName(plan.method) +
          " / 配布単位:&nbsp;" +
          allMenuStore.getters.findAreaLevelJName(plan.area_level) +
          "</div>" +
          "<div>原稿アップロード期限日:&nbsp;" +
          plan.extra?.upload_limit_date +
          "</div>" +
          "<div>配布完了予定日:&nbsp;" +
          plan.accepted_posting_date +
          "</div>";
      } else {
        specification =
          preSpecification +
          "<div>配布中心部:&nbsp;" +
          plan.extra?.central_name +
          "</div>" +
          "<div><span class='font-bold'>用紙サイズ:&nbsp;</span>" +
          allMenuStore.getters.findPaperSizeJName(plan.paper_size) +
          " / 配布部数:&nbsp;" +
          plan.computed_quantity.toLocaleString() +
          "</div>" +
          "<div>用紙の厚さ:&nbsp;" +
          plan.thickness +
          "</div><div>用紙タイプ:&nbsp;" +
          allMenuStore.getters.findPaperTypeJName(plan.paper_type) +
          "</div><div>カラータイプ:&nbsp;" +
          allMenuStore.getters.findColorTypeJName(plan.color_type) +
          "<div>配布方法:&nbsp;" +
          allMenuStore.getters.findMethodsJName(plan.method) +
          " / 配布単位:&nbsp;" +
          allMenuStore.getters.findAreaLevelJName(plan.area_level) +
          "</div>" +
          "<div>原稿アップロード期限日:&nbsp;" +
          plan.extra?.upload_limit_date +
          "</div>" +
          "<div>納品予定日:&nbsp;" +
          this.deliveryDateFormatAM(plan.delivery_limit_date, plan.data_type) +
          "<div>配布完了予定日:&nbsp;" +
          plan.accepted_posting_date +
          "</div>";
      }

      if (plan.extra?.ref_text && device.mobile) {
        specification =
          specification +
          "<div>参照テキスト:&nbsp;" +
          plan.extra?.ref_text +
          "</div>";
      }
      return specification;
    },
    removeData() {
      estimateStore.commit("resetEstimationStore");
      this.$router.push("/map");
    },
    async savePlan() {
      let respData = "";
      if (
        estimateStore.state.orderType === "posting" ||
        estimateStore.state.orderType === "posting_and_print"
      ) {
        const saveData = this.postingData;
        saveData.org_type = authStore.orgType;
        saveData.invoice_allowed_flag = authStore.invoiceAllowedFlag;
        saveData.extra.user_name = authStore.state.name;
        saveData.extra.ref_text = this.reffText;
        respData = await backendApi.saveEstimationPlanPosting(saveData);
      } else if (estimateStore.state.orderType === "geenie") {
        const saveData = this.geenieData;
        saveData.org_type = authStore.orgType;
        saveData.invoice_allowed_flag = authStore.invoiceAllowedFlag;
        saveData.user_name = authStore.state.name;
        respData = await backendApi.genieEstimateSend(saveData, this.reffText);
      } else if (estimateStore.state.orderType === "orikomi") {
        const saveData = this.orikomiData;
        saveData.org_type = authStore.orgType;
        saveData.invoice_allowed_flag = authStore.invoiceAllowedFlag;
        saveData.extra.user_name = authStore.state.name;
        saveData.extra.ref_text = this.reffText;
        respData = await backendApi.saveEstimationOrikomi(saveData);
      }
      if (respData.result === "success") {
        this.$router.push("/cart");
        estimateStore.commit("resetEstimationStore");
      }
    },
  },
  created() {
    if (estimateStore.state.estimate) {
      const test = encryptData.decryptObj(estimateStore.state.estimate);
      this.estimatateObj = test;
    } else {
      this.removeData();
    }
    document.querySelector("body").style.overscrollBehaviorY = "auto";
    document.querySelector("body").style.overflow = "auto";
  },
  unmounted() {
    estimateStore.commit("resetEstimationStore");
  },
  computed: {
    postingData() {
      return this.estimatateObj.posting;
    },
    geenieData() {
      return this.estimatateObj.geenie;
    },
    orikomiData() {
      return this.estimatateObj;
    },
  },
};
</script>

<style scoped lang="scss">
$grey-color: #cbcbcb;
$light-grey: #ebebeb;
// $base-color: #2a7fff;
// $sec-color: #e9f2ff;
$sec-color: #95c41c4d;
$base-color: #95c41c;
$orange-color: #ff8c00;
$red-color: #cd0000;

.icon-circle {
  border: 1px solid $base-color;
  background: white;
  margin-left: 10px;
  margin-right: 10px;
  color: $base-color;
  border-radius: 10px;
  padding: 4px 12px;
  &:hover {
    background: $sec-color;
  }
}

.cart-content {
  text-align: left;
  border: none;
  padding-bottom: 16px;
  .title {
    margin-bottom: 100px;
    padding-bottom: 50px;
    font-size: 20px;
  }
}
.cart-content-mobile {
  .title {
    font-size: 20px;
  }
}

.box-left-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  padding-bottom: 24px;
  display: flex;
  justify-content: space-between;
}

.confirm-page-body {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 47px;
  gap: 40px;

  .confirm-button {
    background-color: $orange-color;
    width: 298px;
    height: 40px;
    border-radius: 8px;
    text-align: center;
    color: white;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 100px;
  }

  .page-title {
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 0;
  }

  .box-data {
    width: 67.3vw;
    border: 1px solid $grey-color;
    border-radius: 8px;
    padding: 24px;
    display: flex;

    .box-data-if {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .box-data-left {
      width: 60%;
      padding-right: 24px;
      display: flex;
      flex-direction: column;
      border-right: 1px solid $grey-color;
    }

    .body-data-info {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 4px;
      color: black;
    }

    .body-input-ref {
      margin-top: 16px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 4px;
    }

    .input-ref {
      padding: 10px 12px;
      border-radius: 8px;
      border: none;
      width: 350px;
      color: $grey-color;
      background-color: $light-grey;
    }

    .box-data-right {
      width: 40%;
      margin-left: 24px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
    }
  }

  .normal-size-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
  }

  .font-size-large {
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
  }

  .font-bold {
    font-weight: 700;
  }

  .font-orange {
    color: $orange-color;
  }

  .font-red {
    color: $red-color;
  }

  .color-black {
    color: black !important ;
  }

  .opacity-40 {
    opacity: 40%;
  }
}

.product-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .left-col {
    text-align: left;
  }
  .right-col {
    text-align: right;
  }
}

.geocode-geenie {
  text-align: left;
}

.brand-title {
  text-align: left;
  font-weight: 700;
  margin-top: 10px;
}
</style>
